export default __webpack_public_path__ + "static/media/img_chart_grade_C0.f0a6998841a3f90ae835e1593b41e6c9.svg";